function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 808.608,
  cy: 74.6777,
  r: 5.38,
  transform: "rotate(-45 808.608 74.6777)",
  fill: "#002131"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 849.608,
  cy: 52.6777,
  r: 5.38,
  transform: "rotate(-45 849.608 52.6777)",
  fill: "#002131"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 890.608,
  cy: 33.6777,
  r: 5.38,
  transform: "rotate(-45 890.608 33.6777)",
  fill: "#004261"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 944.608,
  cy: 23.6777,
  r: 5.38,
  transform: "rotate(-45 944.608 23.6777)",
  fill: "#004261"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 999.608,
  cy: 41.6777,
  r: 5.38,
  transform: "rotate(-45 999.608 41.6777)",
  fill: "#0080BD"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 1040.61,
  cy: 70.6777,
  r: 5.38,
  transform: "rotate(-45 1040.61 70.6777)",
  fill: "#0080BD"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 1084.61,
  cy: 89.6777,
  r: 5.38,
  transform: "rotate(-45 1084.61 89.6777)",
  fill: "#008DD0"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 1129.61,
  cy: 82.6777,
  r: 5.38,
  transform: "rotate(-45 1129.61 82.6777)",
  fill: "#02A7F5"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 1174.61,
  cy: 70.6777,
  r: 5.38,
  transform: "rotate(-45 1174.61 70.6777)",
  fill: "#02A7F5"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 190.608,
  cy: 106.678,
  r: 5.38,
  transform: "rotate(-45 190.608 106.678)",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 231.608,
  cy: 84.6777,
  r: 5.38,
  transform: "rotate(-45 231.608 84.6777)",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 272.608,
  cy: 65.6777,
  r: 5.38,
  transform: "rotate(-45 272.608 65.6777)",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 326.608,
  cy: 55.6777,
  r: 5.38,
  transform: "rotate(-45 326.608 55.6777)",
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 381.608,
  cy: 73.6777,
  r: 5.38,
  transform: "rotate(-45 381.608 73.6777)",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 422.608,
  cy: 102.678,
  r: 5.38,
  transform: "rotate(-45 422.608 102.678)",
  fill: "black"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 466.608,
  cy: 121.678,
  r: 5.38,
  transform: "rotate(-45 466.608 121.678)",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 511.608,
  cy: 114.678,
  r: 5.38,
  transform: "rotate(-45 511.608 114.678)",
  fill: "black"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 556.608,
  cy: 102.678,
  r: 5.38,
  transform: "rotate(-45 556.608 102.678)",
  fill: "black"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 1316,
  cy: 75,
  r: 75,
  fill: "#009BE5"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M1291.18 76.6855C1291.18 79.6803 1294.55 81.1777 1301.29 81.1777C1310.4 81.1777 1319.14 79.5664 1327.51 76.3438C1330.14 75.3346 1332.83 74.2279 1335.56 73.0234L1341.08 69.8008C1347.04 66.4154 1351.27 64.7227 1353.78 64.7227C1354.85 64.7227 1355.7 64.8854 1356.32 65.2109C1357.94 65.7318 1359.25 66.5618 1360.22 67.7012C1362.01 69.7845 1362.91 71.3796 1362.91 72.4863C1362.91 73.5605 1362.63 74.9603 1362.08 76.6855C1361.52 78.3783 1360.78 80.2337 1359.83 82.252C1358.89 84.2376 1357.8 86.3047 1356.56 88.4531C1355.32 90.6016 1354.01 92.6523 1352.61 94.6055C1349.48 99.0651 1346.7 102.288 1344.26 104.273C1343.34 105.413 1342.22 106.682 1340.89 108.082C1339.55 109.482 1337.71 110.963 1335.37 112.525C1333.06 114.12 1330.63 115.52 1328.09 116.725C1325.59 117.962 1323.02 119.02 1320.38 119.898C1317.77 120.81 1315.27 121.559 1312.86 122.145C1308.24 123.284 1304.67 123.854 1302.17 123.854C1299.69 123.854 1297.89 123.349 1296.75 122.34C1295.64 121.363 1295.09 120.11 1295.09 118.58C1295.09 117.083 1295.61 115.585 1296.65 114.088C1297.72 112.59 1299.15 111.142 1300.95 109.742C1302.77 108.342 1304.87 106.992 1307.24 105.689C1309.65 104.42 1312.18 103.215 1314.81 102.076C1319.6 99.9928 1324.92 98.1211 1330.78 96.4609C1334.1 91.9036 1337.06 87.2487 1339.67 82.4961L1337.27 83.8633C1336.46 84.2865 1335.66 84.6771 1334.88 85.0352C1328.99 88.5833 1321.55 91.7409 1312.57 94.5078C1301.89 97.7956 1291.72 99.4395 1282.05 99.4395C1276.61 99.4395 1272.3 97.6328 1269.11 94.0195C1266.21 90.7318 1264.76 86.5651 1264.76 81.5195C1264.76 76.181 1268.36 70.4355 1275.55 64.2832C1281.87 58.8796 1290.41 53.6224 1301.19 48.5117C1310.96 43.8242 1321.06 39.9831 1331.51 36.9883C1341.83 33.9935 1350.16 32.4961 1356.51 32.4961C1360.26 32.4961 1362.79 33.7656 1364.13 36.3047C1364.65 37.2487 1364.91 38.5996 1364.91 40.3574C1364.91 42.0827 1364.26 43.6289 1362.96 44.9961C1361.65 46.3633 1359.96 47.4375 1357.88 48.2188C1354.14 49.651 1349.55 50.3672 1344.11 50.3672C1338.67 50.3672 1333.76 50.0417 1329.36 49.3906C1323.18 51.4089 1316.88 54.3711 1310.47 58.2773C1305.1 61.5326 1300.46 65.0482 1296.55 68.8242C1292.97 72.2747 1291.18 74.8952 1291.18 76.6855Z",
  fill: "white"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M700.5 7C657.704 7 623 41.9794 623 85.1298C623 119.65 645.206 148.936 676 159.268C679.873 159.991 681.295 157.573 681.295 155.509C681.295 153.646 681.223 147.491 681.19 140.963C659.629 145.689 655.079 131.744 655.079 131.744C651.554 122.713 646.474 120.313 646.474 120.313C639.443 115.463 647.004 115.563 647.004 115.563C654.787 116.114 658.885 123.614 658.885 123.614C665.797 135.559 677.015 132.105 681.437 130.109C682.133 125.059 684.141 121.613 686.358 119.662C669.144 117.686 651.048 110.986 651.048 81.0495C651.048 72.5199 654.075 65.5497 659.033 60.0784C658.229 58.1102 655.576 50.164 659.784 39.4021C659.784 39.4021 666.292 37.3022 681.102 47.4108C687.284 45.6792 693.914 44.8115 700.5 44.7821C707.087 44.8115 713.722 45.6792 719.915 47.4108C734.708 37.3022 741.207 39.4021 741.207 39.4021C745.425 50.164 742.771 58.1102 741.967 60.0784C746.935 65.5497 749.942 72.5193 749.942 81.0495C749.942 111.058 731.812 117.666 714.555 119.599C717.335 122.024 719.811 126.779 719.811 134.068C719.811 144.522 719.721 152.935 719.721 155.509C719.721 157.588 721.116 160.024 725.045 159.257C755.822 148.914 778 119.639 778 85.1298C778 41.9794 743.301 7 700.5 7Z",
  fill: "#161614"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M652.027 118.298C651.856 118.686 651.25 118.802 650.698 118.536C650.136 118.281 649.82 117.752 650.002 117.362C650.17 116.963 650.776 116.851 651.337 117.12C651.901 117.374 652.222 117.908 652.027 118.298V118.298ZM655.839 121.727C655.469 122.072 654.747 121.912 654.256 121.366C653.749 120.821 653.654 120.093 654.029 119.742C654.41 119.397 655.111 119.558 655.619 120.104C656.126 120.655 656.225 121.378 655.838 121.728L655.839 121.727ZM658.454 126.114C657.979 126.447 657.202 126.135 656.723 125.44C656.248 124.746 656.248 123.913 656.733 123.579C657.214 123.245 657.979 123.545 658.465 124.234C658.939 124.941 658.939 125.774 658.454 126.115L658.454 126.114ZM662.877 131.196C662.452 131.668 661.547 131.541 660.885 130.897C660.208 130.267 660.019 129.373 660.445 128.9C660.875 128.427 661.784 128.56 662.452 129.199C663.125 129.828 663.33 130.729 662.877 131.196H662.877ZM668.593 132.912C668.406 133.523 667.534 133.801 666.657 133.542C665.78 133.274 665.207 132.557 665.383 131.939C665.566 131.323 666.441 131.033 667.325 131.311C668.201 131.578 668.776 132.289 668.593 132.912H668.593ZM675.099 133.639C675.121 134.284 674.376 134.818 673.455 134.83C672.528 134.85 671.778 134.328 671.769 133.695C671.769 133.044 672.496 132.515 673.422 132.499C674.344 132.481 675.099 132.999 675.099 133.639V133.639ZM681.489 133.392C681.6 134.021 680.959 134.667 680.045 134.838C679.145 135.004 678.312 134.616 678.198 133.992C678.086 133.348 678.738 132.703 679.636 132.535C680.553 132.375 681.373 132.753 681.489 133.392",
  fill: "#161614"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M42.2344 53.8125C42.2344 44.2079 50.0204 36.4219 59.625 36.4219H69.5625H81.9844C81.9844 30.9339 75.5697 26.4844 64.5938 26.4844H44.7188C40.0258 26.4844 35.6085 28.693 32.7938 32.4469C30.8584 35.0281 29.8125 38.1659 29.8125 41.3906V68.7188L42.2344 61.2656V53.8125Z",
  fill: "#4D2817"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M27.3281 91.5502V68.7188H22.3594C16.8714 68.7188 12.4219 73.1683 12.4219 78.6562V88.5938C12.4219 94.0817 16.8714 98.5312 22.3594 98.5312H29.0895C27.9592 96.4021 27.3281 94.0171 27.3281 91.5502Z",
  fill: "#606060"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M94.4062 88.5938V78.6562C94.4062 73.1683 89.9567 68.7188 84.4688 68.7188H81.9844V88.5938H94.4062Z",
  fill: "#606060"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M69.5625 43.875V36.4219H59.625C50.0204 36.4219 42.2344 44.2079 42.2344 53.8125V61.2656H52.1719C61.7765 61.2656 69.5625 53.4796 69.5625 43.875Z",
  fill: "#4D2817"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M69.5625 43.875C69.5625 53.4796 61.7765 61.2656 52.1719 61.2656H67.0781C76.6827 61.2656 84.4688 53.4796 84.4688 43.875V36.4219H81.9844H69.5625V43.875Z",
  fill: "#66351E"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M67.0781 61.2656H81.9844C84.6551 61.2656 87.1767 60.6445 89.4375 59.5688V59.5415V59.5688C95.3081 56.7764 99.375 50.8064 99.375 43.875V36.4219H84.4688V43.875C84.4688 53.4796 76.6827 61.2656 67.0781 61.2656Z",
  fill: "#4D2817"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M39.75 26.4844H34.7812C30.0883 26.4844 25.671 28.693 22.8562 32.4469C20.9209 35.0281 19.875 38.1659 19.875 41.3906V68.7188H22.3594H29.8125V41.3906C29.8125 38.1659 30.8584 35.0281 32.7938 32.4469C35.6085 28.693 40.0258 26.4844 44.7188 26.4844H39.75Z",
  fill: "#66351E"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M19.875 91.0781V81.1406C19.875 76.5147 23.05 72.6615 27.3281 71.5534V68.7188H22.3594C16.8714 68.7188 12.4219 73.1683 12.4219 78.6562V88.5938C12.4219 94.0817 16.8714 98.5312 22.3594 98.5312H23.3034C21.219 96.7102 19.875 94.0643 19.875 91.0781Z",
  fill: "#878787"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M84.4688 68.7188H81.9844V73.6875C87.4724 73.6875 91.9219 78.137 91.9219 83.625V88.5938H94.4062V78.6562C94.4062 73.1683 89.9567 68.7188 84.4688 68.7188Z",
  fill: "#878787"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M94.4062 126.739C101.32 129.539 106.828 132.731 106.828 135.797V170.578H2.48438V135.797C2.48438 127.564 42.2344 118.406 42.2344 118.406H67.0781L94.4062 126.739Z",
  fill: "#D0382A"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M94.4062 134.192L67.0781 125.859H42.2344C42.2344 125.859 7.155 133.944 2.9092 141.747L2.48438 135.797C2.48438 127.564 42.2344 118.406 42.2344 118.406H67.0781L94.4062 126.739C101.32 129.539 106.828 132.731 106.828 135.797L106.398 141.807C105.032 139.198 100.242 136.555 94.4062 134.192V134.192Z",
  fill: "#B33024"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M39.75 61.2656H81.9844V91.5502C81.9844 95.9748 80.0192 100.168 76.6206 103.001L64.9366 109.403C63.0808 110.421 61.0013 110.953 58.8847 110.953H50.4254C48.3112 110.953 46.2293 110.421 44.3734 109.403L32.6894 103.001C29.2933 100.168 27.3281 95.9723 27.3281 91.5502V71.2031L39.75 61.2656Z",
  fill: "#FCE0B9"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M44.3759 109.403C46.2317 110.421 48.3112 110.953 50.4278 110.953H58.8871C61.0013 110.953 63.0832 110.421 64.9391 109.403L67.0781 108.23V123.375C60.2188 130.234 49.0937 130.234 42.2344 123.375V108.23L44.3759 109.403Z",
  fill: "#FCE0B9"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M42.2344 108.23L44.3759 109.403C46.2317 110.421 48.3112 110.953 50.4278 110.953H58.8871C61.0013 110.953 63.0832 110.421 64.9391 109.403L67.0781 108.23V123.375C66.6856 123.768 66.2757 124.13 65.8583 124.478L42.2344 109.179V108.23Z",
  fill: "#F5CBA1"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M59.625 81.1406C58.2536 81.1406 57.1406 82.2536 57.1406 83.625V110.953H58.8847C60.9989 110.953 63.0808 110.421 64.9366 109.403L76.6206 103.001C80.0192 100.168 81.9844 95.9723 81.9844 91.5502V81.1406H59.625Z",
  fill: "#F5CBA1"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M64.5938 88.5938V109.564V120.891V143.25H99.375V101.016C99.375 98.2704 101.599 96.0469 104.344 96.0469C107.089 96.0469 109.312 98.2704 109.312 101.016V143.25H144.094V88.5938H64.5938Z",
  fill: "#383838"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M104.344 96.0469C101.599 96.0469 99.375 98.2704 99.375 101.016V143.25V160.641H109.312V143.25V101.016C109.312 98.2704 107.089 96.0469 104.344 96.0469Z",
  fill: "#383838"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M81.9844 160.641V170.578H126.703V160.641H109.312H99.375H81.9844Z",
  fill: "#383838"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M52.1719 56.2969H42.2344V61.2656H52.1719C61.7765 61.2656 69.5625 53.4796 69.5625 43.875V38.9062C69.5625 48.5108 61.7765 56.2969 52.1719 56.2969Z",
  fill: "#3D2012"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M67.0781 56.2969H64.3304C61.1951 59.3676 56.9071 61.2656 52.1719 61.2656H67.0781C76.6827 61.2656 84.4688 53.4796 84.4688 43.875V38.9062C84.4688 48.5108 76.6827 56.2969 67.0781 56.2969Z",
  fill: "#4D2817"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M89.4375 54.6C87.1767 55.6758 84.6551 56.2969 81.9844 56.2969H79.2367C76.1014 59.3676 71.8133 61.2656 67.0781 61.2656H81.9844C84.6551 61.2656 87.1767 60.6445 89.4375 59.5688C95.3081 56.7764 99.375 50.8064 99.375 43.875V38.9062C99.375 45.8401 95.3081 51.8076 89.4375 54.6Z",
  fill: "#3D2012"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3906 160.641L42.2344 155.672H57.1406C61.2572 155.672 64.5938 159.008 64.5938 163.125V170.578H17.3906V160.641Z",
  fill: "#FCE0B9"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M94.4062 94.7103V143.25H99.375V101.016C99.375 98.2704 101.599 96.0469 104.344 96.0469C107.089 96.0469 109.312 98.2704 109.312 101.016V143.25H114.281V94.7103C114.281 91.3315 109.832 88.5938 104.344 88.5938C98.8558 88.5938 94.4062 91.3315 94.4062 94.7103Z",
  fill: "#262626"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M81.9844 165.609H126.703V170.578H81.9844V165.609Z",
  fill: "#262626"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M42.2344 83.0039C39.837 83.0039 37.8867 81.0537 37.8867 78.6562C37.8867 76.2588 39.837 74.3086 42.2344 74.3086C44.6318 74.3086 46.582 76.2588 46.582 78.6562C46.582 81.0537 44.6318 83.0039 42.2344 83.0039ZM42.2344 78.0352C41.8915 78.0352 41.6133 78.3134 41.6133 78.6562C41.6133 79.3395 42.8555 79.3395 42.8555 78.6562C42.8555 78.3134 42.5772 78.0352 42.2344 78.0352Z",
  fill: "black"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M67.0781 83.0039C64.6807 83.0039 62.7305 81.0537 62.7305 78.6562C62.7305 76.2588 64.6807 74.3086 67.0781 74.3086C69.4755 74.3086 71.4258 76.2588 71.4258 78.6562C71.4258 81.0537 69.4755 83.0039 67.0781 83.0039ZM67.0781 78.0352C66.7353 78.0352 66.457 78.3134 66.457 78.6562C66.457 79.3395 67.6992 79.3395 67.6992 78.6562C67.6992 78.3134 67.421 78.0352 67.0781 78.0352Z",
  fill: "black"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M144.094 86.1094H96.8906V78.6562C96.8906 74.6142 94.9205 71.0516 91.9219 68.7833V61.0619C97.8521 57.6186 101.859 51.2138 101.859 43.875V36.4219C101.859 35.0505 100.746 33.9375 99.375 33.9375H84.1209C82.6651 28.6731 76.474 24 64.5938 24H44.7188H34.7812C29.3355 24 24.1357 26.6011 20.8687 30.9563C18.6254 33.945 17.3906 37.6516 17.3906 41.3906V67.2704C13.0057 69.1908 9.9375 73.5732 9.9375 78.6562V88.5938C9.9375 94.591 14.2131 99.6095 19.875 100.765V122.143C9.43566 125.802 0 130.555 0 135.797V170.578C0 171.949 1.113 173.062 2.48438 173.062H81.9844H126.703C128.074 173.062 129.188 171.949 129.188 170.578V160.641C129.188 159.269 128.074 158.156 126.703 158.156H111.797V145.734H144.094C145.465 145.734 146.578 144.621 146.578 143.25V88.5938C146.578 87.2224 145.465 86.1094 144.094 86.1094V86.1094ZM84.4688 86.1094V71.2031C88.5779 71.2031 91.9219 74.5471 91.9219 78.6562V86.1094H84.4688ZM44.7188 112.302C46.5274 113.042 48.4677 113.438 50.4278 113.438H58.8847C59.9629 113.438 61.0461 113.301 62.1094 113.065V124.011C56.5469 127.198 49.5583 126.545 44.7188 122.302V112.302ZM64.5938 86.1094C63.2224 86.1094 62.1094 87.2224 62.1094 88.5938V107.912C61.061 108.27 59.9678 108.469 58.8847 108.469H50.4278C48.7335 108.469 47.0541 108.039 45.5684 107.227L34.1055 100.944C31.3727 98.5809 29.8125 95.1699 29.8125 91.5502V71.2031C30.282 71.2031 30.6945 71.0392 31.0696 70.8131L31.092 70.8503L42.9225 63.75H79.5V86.1094H64.5938ZM81.9844 38.9062V43.875C81.9844 52.0958 75.2989 58.7812 67.0781 58.7812H65.2745C69.4159 55.1367 72.0469 49.8127 72.0469 43.875V38.9062H81.9844ZM67.0781 43.875C67.0781 52.0958 60.3927 58.7812 52.1719 58.7812H44.7188V53.8125C44.7188 45.5917 51.4042 38.9062 59.625 38.9062H67.0781V43.875ZM86.9531 66.4853C86.1507 66.3213 85.3184 66.2344 84.4688 66.2344V63.5786C85.3159 63.4717 86.1432 63.3078 86.9531 63.0966V66.4853ZM96.8906 43.875C96.8906 52.0958 90.2052 58.7812 81.9844 58.7812H80.1807C84.3222 55.1367 86.9531 49.8127 86.9531 43.875V38.9062H96.8906V43.875ZM34.7812 33.9375C37.1141 30.8271 40.8282 28.9688 44.7188 28.9688H64.5938C72.1537 28.9688 76.8939 31.2121 78.6752 33.9375H59.625C48.6664 33.9375 39.75 42.8539 39.75 53.8125V59.8595L32.2969 64.3313V41.3906C32.2969 38.7199 33.1788 36.0716 34.7812 33.9375ZM22.3594 41.3906C22.3594 38.7199 23.2413 36.0716 24.8438 33.9375C26.6723 31.4978 29.3504 29.8308 32.2969 29.2222C31.7652 29.7638 31.2659 30.3426 30.8062 30.9563C28.5629 33.945 27.3281 37.6516 27.3281 41.3906V66.2344H22.3594V41.3906ZM14.9062 88.5938V78.6562C14.9062 74.5471 18.2502 71.2031 22.3594 71.2031H24.8438V91.5502C24.8438 93.0905 25.0698 94.5935 25.4574 96.0469H22.3594C18.2502 96.0469 14.9062 92.7029 14.9062 88.5938V88.5938ZM24.8438 101.016H27.666C28.6051 102.457 29.7454 103.778 31.1019 104.909C31.2236 105.013 31.3578 105.102 31.4994 105.179L39.75 109.701V116.436C35.6334 117.417 30.287 118.799 24.8438 120.498V101.016ZM4.96875 135.797C4.96875 133.909 10.9909 130.734 19.875 127.509V157.61L16.9037 158.206L17.88 163.078L19.875 162.678V168.094H4.96875V135.797ZM62.1094 168.094H24.8438V161.684L42.4803 158.156H57.1406C59.8809 158.156 62.1094 160.385 62.1094 163.125V168.094ZM79.5 160.641V168.094H67.0781V163.125C67.0781 157.644 62.6212 153.188 57.1406 153.188H42.2344C42.0704 153.188 41.9089 153.202 41.7474 153.237L24.8438 156.616V125.797C29.415 124.304 34.4856 122.851 39.75 121.556V123.375C39.75 124.033 40.0109 124.667 40.4779 125.131C44.361 129.015 49.4987 131.012 54.6712 131.009C57.1953 131.009 59.712 130.48 62.1094 129.516V143.25C62.1094 144.621 63.2224 145.734 64.5938 145.734H96.8906V158.156H81.9844C80.613 158.156 79.5 159.269 79.5 160.641ZM124.219 168.094H84.4688V163.125H124.219V168.094ZM101.859 158.156V101.016C101.859 99.6467 102.975 98.5312 104.344 98.5312C105.713 98.5312 106.828 99.6467 106.828 101.016V158.156H101.859ZM141.609 140.766H111.797V101.016C111.797 96.9065 108.453 93.5625 104.344 93.5625C100.235 93.5625 96.8906 96.9065 96.8906 101.016V140.766H67.0781V91.0781H141.609V140.766Z",
  fill: "black"
});

function SvgFlow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1391,
    height: 174,
    viewBox: "0 0 1391 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow);
export default __webpack_public_path__ + "static/media/flow.4c7929b6.svg";
export { ForwardRef as ReactComponent };